var _rect, _rect2, _rect3, _mask, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeOutline = function SvgHomeOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-outline",
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 19,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-258 -87)",
    fill: "#F2F3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -22,
    y: -25,
    width: 1180,
    height: 600,
    rx: 16,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_247_12747",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 19,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 22,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2 17V11.7059H12.8V17H17.3V9.94118H20L11 2L2 9.94118H4.7V17H9.2Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 17V11.7059H12.8V17H17.3V9.94118H20L11 2L2 9.94118H4.7V17H9.2Z",
    stroke: "#046FD2",
    strokeWidth: 3,
    strokeLinejoin: "round",
    mask: "url(#path-2-outside-1_247_12747)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeOutline);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaG9tZS1vdXRsaW5lIiB2aWV3Qm94PSIwIDAgMjIgMTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB3aWR0aD0iMjIiIGhlaWdodD0iMTkiIGZpbGw9IiNFNUU1RTUiLz4KICAgIDxyZWN0IHdpZHRoPSIxNDQwIiBoZWlnaHQ9IjkwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1OCAtODcpIiBmaWxsPSIjRjJGM0Y4Ii8+CiAgICA8cmVjdCB4PSItMjIiIHk9Ii0yNSIgd2lkdGg9IjExODAiIGhlaWdodD0iNjAwIiByeD0iMTYiIGZpbGw9IndoaXRlIi8+CiAgICA8bWFzayBpZD0icGF0aC0yLW91dHNpZGUtMV8yNDdfMTI3NDciIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMiIgaGVpZ2h0PSIxOSIgZmlsbD0iYmxhY2siPgogICAgICAgIDxyZWN0IGZpbGw9IndoaXRlIiB3aWR0aD0iMjIiIGhlaWdodD0iMTkiLz4KICAgICAgICA8cGF0aCBkPSJNOS4yIDE3VjExLjcwNTlIMTIuOFYxN0gxNy4zVjkuOTQxMThIMjBMMTEgMkwyIDkuOTQxMThINC43VjE3SDkuMloiLz4KICAgIDwvbWFzaz4KICAgIDxwYXRoIGQ9Ik05LjIgMTdWMTEuNzA1OUgxMi44VjE3SDE3LjNWOS45NDExOEgyMEwxMSAyTDIgOS45NDExOEg0LjdWMTdIOS4yWiIgc3Ryb2tlPSIjMDQ2RkQyIiBzdHJva2Utd2lkdGg9IjMiCiAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIiBtYXNrPSJ1cmwoI3BhdGgtMi1vdXRzaWRlLTFfMjQ3XzEyNzQ3KSIvPgo8L3N2Zz4K";